import { render, staticRenderFns } from "./phone-manufacturer.vue?vue&type=template&id=2d2f5b3a&scoped=true"
import script from "./phone-manufacturer.vue?vue&type=script&lang=js"
export * from "./phone-manufacturer.vue?vue&type=script&lang=js"
import style0 from "./phone-manufacturer.vue?vue&type=style&index=0&id=2d2f5b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_d79148f6156699cf80ef22aa45ce0a5c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2f5b3a",
  null
  
)

export default component.exports